import navBar from '../lists/navbar/bg';

const data = {
  ...navBar,
};
export default data;
